import { Component, ChangeDetectionStrategy } from '@angular/core';
import { defaultConfig } from 'src/app/app.config';
import { buildBaseUrl } from '@core/utils/url.utils';

/**
 * #278528 — Footer institucional, único para toda la plataforma.
 *
 * Antes vivía escrito a mano dentro de home-public y de la plantilla de pre-afiliación, así que no
 * aparecía en ninguna vista autenticada aunque el criterio lo pide «fijo en la navegación dentro de
 * toda la plataforma». Las dos copias ya habían divergido, de ahí que se centralice en vez de
 * agregar una tercera.
 */
@Component({
  standalone: true,
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
  /** Logo parametrizable (`superAppLogos`), con el asset empaquetado como respaldo. */
  mainLogo = `${buildBaseUrl(defaultConfig.serverEntryPoint)}/api/branding/logo/mainLogo`;

  onMainLogoError(): void {
    // Si la URL del CMS falla, cae al asset empaquetado.
    this.mainLogo = '';
  }
}
